module.exports = __webpack_public_path__ + "img/music_2.0c567ba1.png";